export const environment = {
  envName: 'sandbox',
  production: true,
  coreApiUrl: 'https://sandbox-core.masteremployee.com/api/',
  // coreApiUrl: 'http://127.0.0.1:80/api/',
};
